import React, { Suspense, lazy, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import MobileStickyCTA from "./components/MobileStickyCTA";
import EligibilityModal from "./components/EligibilityModal";
import { EligibilityModalProvider, useEligibilityModal } from "./context/EligibilityModalContext";
import Home from "./pages/Home";
import { Toaster } from "./components/ui/sonner";
import { installTapTracker } from "./lib/tapTracker";
const About = lazy(() => import("./pages/About"));
const Services = lazy(() => import("./pages/Services"));
const Programs = lazy(() => import("./pages/Programs"));
const ProgramDetail = lazy(() => import("./pages/ProgramDetail"));
const CountryUniversities = lazy(() => import("./pages/CountryUniversities"));
const SuccessStories = lazy(() => import("./pages/SuccessStories"));
const Gallery = lazy(() => import("./pages/Gallery"));
const Contact = lazy(() => import("./pages/Contact"));
const Ausbildung = lazy(() => import("./pages/Ausbildung"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const GeorgiaStudyPage = lazy(() => import("./pages/GeorgiaStudyPage"));
const MoldovaStudyPage = lazy(() => import("./pages/MoldovaStudyPage"));
const BulgariaStudyPage = lazy(() => import("./pages/BulgariaStudyPage"));
const MaltaStudyPage = lazy(() => import("./pages/MaltaStudyPage"));
const GermanyStudyPage = lazy(() => import("./pages/GermanyStudyPage"));
const UKStudyPage = lazy(() => import("./pages/UKStudyPage"));
const FranceStudyPage = lazy(() => import("./pages/FranceStudyPage"));
const AustriaStudyPage = lazy(() => import("./pages/AustriaStudyPage"));

// Scroll to top component
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

// Global modal + sticky CTA wired to the context
function GlobalUI() {
  const { isOpen, close, open } = useEligibilityModal();
  useEffect(() => installTapTracker(), []);
  return (
    <>
      <MobileStickyCTA onEligibilityClick={() => open('mobile-sticky')} />
      <EligibilityModal isOpen={isOpen} onClose={close} />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <EligibilityModalProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Header />
          <Suspense fallback={<div className="min-h-screen" data-testid="page-loading" />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/programs" element={<Programs />} />
            <Route path="/programs/:programSlug" element={<ProgramDetail />} />
            <Route path="/programs/:programSlug/:countrySlug" element={<CountryUniversities />} />
            <Route path="/success-stories" element={<SuccessStories />} />
            <Route path="/ausbildung" element={<Ausbildung />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />

            {/* Country study-guide pages — France, Germany, UK
                and Georgia, Bulgaria, Moldova (existing destinations w/ program details) */}
            <Route path="/study-in-france"   element={<FranceStudyPage />} />
            <Route path="/study-in-germany"  element={<GermanyStudyPage />} />
            <Route path="/study-in-uk"       element={<UKStudyPage />} />
            <Route path="/study-in-georgia"  element={<GeorgiaStudyPage />} />
            <Route path="/study-in-bulgaria" element={<BulgariaStudyPage />} />
            <Route path="/study-in-moldova"  element={<MoldovaStudyPage />} />
            <Route path="/study-in-austria"  element={<AustriaStudyPage />} />
            <Route path="/study-in-malta"    element={<MaltaStudyPage />} />
          </Routes>
          </Suspense>
          <Footer />
          <WhatsAppButton />
          <GlobalUI />
          <Toaster />
        </BrowserRouter>
      </EligibilityModalProvider>
    </div>
  );
}

export default App;
